module.exports = __webpack_public_path__ + "img/right_icon_0.d38faee.png";